// Components==============
import React from 'react';
import './index.module.scss';
// =========================

export default function Container({ children }) {
    return <div styleName="container">{children}</div>;
}
